// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import FreeShippingBannerView from '../views/FreeShippingBannerView';

export const FreeShippingBannerContainer = ({ navigation, labels }) => {
  return <FreeShippingBannerView labels={labels} navigation={navigation} />;
};

FreeShippingBannerContainer.propTypes = {
  navigation: PropTypes.shape({}).isRequired,
};

const mapStateToProps = () => {
  return {};
};

export default connect(mapStateToProps)(FreeShippingBannerContainer);
